// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"1f8d46ca","970":"cde7a172","977":"4b3215a8"}[chunkId] + ".chunk.js";
};